<template>
  <section class="videowrapper" :class="{ desktop: $isDesktop }">
    <iframe
      id="youtubeplayer"
      type="text/html"
      frameborder="0"
      :width="width"
      :height="height"
      :src="`https://www.youtube.com/embed/${youtubeVideoID}?autoplay=0&origin=https://pitchup.com&loop=1&modestbranding=1&rel=0`"
      allowfullscreen
    />
  </section>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    youtubeVideoID?: string
    width?: number
    height?: number
  }>(),
  {
    youtubeVideoID: '',
    width: 640,
    height: 360,
  },
)
</script>

<style scoped>
.videowrapper {
  position: relative;
  /* 16:9 */
  padding-bottom: 56.25%;
  padding-top: 25px;
  height: 0;
  margin: 0 -1em;
  border-bottom: 4px solid var(--colour-page-background);
  background-color: black;
}

.videowrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  /* set max width of vid to native size */
  max-width: 640px;
  max-height: 360px;
}

/* desktop & tablet */
.videowrapper.desktop {
  margin: auto;
  width: 100%;
}

.videowrapper.desktop :deep(iframe) {
  max-height: 788px;
  max-width: 1400px;
}
</style>
